import "./src/styles/globals.css";
import React from "react";
import Layout from "./src/layouts";
// import { StoreProvider } from "./src/context/storeContext";
import { Toaster } from "react-hot-toast";
// import "@fontsource/handlee";
// import "@fontsource/manrope/300.css";
// import "@fontsource/manrope/400.css";
// import "@fontsource/manrope/500.css";
// import "@fontsource/manrope/600.css";
// import "@fontsource/manrope/700.css";
// import "@fontsource/manrope/800.css";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import "./src/assets/scss/style.scss";
import "./src/styles/tailwind.css";
export const wrapPageElement = ({ element, props }) => {
  return (
    <div>
      <Layout {...props}>{element}</Layout>
      <Toaster />
    </div>
  );
};

export const onRouteUpdate = () => {
  if (typeof window !== "undefined") {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }
};
